import { createRouter } from "@tanstack/react-router";
import { BootScreen } from "./components/shell/BootScreen";
import { queryClient, setUnauthorizedHandler } from "./query-client";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // Route guards fetch session + setup status before anything renders; show the boot screen if that
  // takes noticeably long instead of an empty document.
  defaultPendingComponent: BootScreen,
  defaultPendingMs: 150,
  defaultPendingMinMs: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

setUnauthorizedHandler(() => {
  const here = router.state.location;
  if (here.pathname === "/login" || here.pathname === "/setup") return;
  queryClient.clear();
  void router.navigate({ to: "/login", search: { redirect: here.href } });
});
